import {useState, useEffect, Dispatch, SetStateAction, CSSProperties} from 'react'
import {RIF, sortBy, _} from '../../lib'
import {selectTheme, selectMethod} from '../../store'
import {GarminGIcon, GarminLIcon} from '../../asset/image'
import {AdherenceViewedByType, Checkbox} from '..'
import {
  TaskStateType,
  SelectTaskListItem,
  HandleToggleTaskPayload,
  GarminDirect,
  getTaskContentName,
  AdherenceViewTag,
} from '../../model'
import {IGarminDevice, ITask, TaskType} from '../../shared/db'

export const ViewMenu = (props: {
  adherenceViewedByType: AdherenceViewedByType
  setAdherenceViewedByType: Dispatch<SetStateAction<AdherenceViewedByType>>
  viewTagList: AdherenceViewTag[]
  setViewTagList: Dispatch<SetStateAction<AdherenceViewTag[]>>
  viewDatatype: GarminDirect
  setViewDatatype: Dispatch<SetStateAction<GarminDirect>>
  garminDirectEnabled: boolean
}) => {
  const {color, fontWeight} = selectTheme()
  // const colorTranslator = createTaskColorTranslator()

  const {
    adherenceViewedByType,
    setAdherenceViewedByType,
    viewTagList,
    setViewTagList,
    viewDatatype,
    setViewDatatype,
    garminDirectEnabled,
  } = props

  const method = selectMethod()
  const garminConnect: boolean = method?.garminConnectEnable
  const garminDeviceTask: ITask | undefined = _.find(method?.taskList, {type: TaskType.GarminDevice}) // TODO: check type
  const methodTaskListWithoutGarmin: Omit<TaskStateType, 'garminDevice'>[] = (method.taskList ?? [])
    ?.filter((item: TaskStateType) => item.type !== TaskType.GarminDevice && item.enabled)
    ?.sort(sortBy('index'))
  const [selectTaskList, setSelectTaskList] = useState<SelectTaskListItem[]>([])
  const [garminDirectList, setGarminDirectList] = useState<GarminDirect[]>([])

  const GarminDirectypeRef: Partial<Record<keyof IGarminDevice, string>> = {
    heartRateEnable: 'Heart Rate',
    pulseOxEnable: 'Oxygen Saturation',
    stressEnable: 'Stress',
    stepsEnable: 'Steps',
    respirationEnable: 'Respiration',
    bbiEnable: 'Heart Rate Interval (BBI)',
    zeroCrossingEnable: 'Zero Crossings',
    actigraphyEnable: 'Actigraphy',
  }

  // get available item and change name then store in list
  useEffect(() => {
    if (!garminDeviceTask?.garminDevice) return
    Object.entries(GarminDirectypeRef).filter(
      ([key]) => garminDeviceTask?.garminDevice && garminDeviceTask.garminDevice[key as keyof IGarminDevice],
    )
    // setGarminDirectList([])
    if (garminDirectEnabled && garminDeviceTask?.garminDevice) {
      Object.entries(garminDeviceTask.garminDevice).map(([key, value]) => {
        if (value === true && GarminDirectypeRef[key as keyof IGarminDevice]) {
          setGarminDirectList((prev) => [...prev, GarminDirectypeRef[key as keyof IGarminDevice] as GarminDirect])
        }
      })
    }
  }, [garminDeviceTask])

  // useEffect(() => {
  //   setViewDatatype(garminDirectList[0])
  // }, [garminDirectList])

  // useEffect(() => {
  //   let taskList: {id: string; name: string; color: any; index: number}[] = []
  //   if (method?.dexcomIntegrationId) {
  //     taskList.push({
  //       id: method.dexcomIntegrationId,
  //       name: 'Dexcom App',
  //       color: color.dexcomGreen,
  //       index: 0,
  //     })
  //   }

  //   const sanitizedMethodTaskListWithoutGarmin = methodTaskListWithoutGarmin?.map((item, index: number) => ({
  //     id: item.id,
  //     name: item[getTaskContentName(item.type)]?.name ?? '',
  //     color: item.color ? `#${item.color}` : colorTranslator(index),
  //     index: item.index || index,
  //   }))
  //   taskList = taskList.concat(sanitizedMethodTaskListWithoutGarmin)

  //   setSelectTaskList((oldArr) => [...oldArr, ...taskList])
  // }, [])

  // add or remove task depend on target in viewTagList or not
  const handleToggleTask = (checked: boolean, obj: HandleToggleTaskPayload) => {
    // edge case: if diff task have same name, should compare by 'id'
    if (obj.type === 'task') {
      const targetInList = viewTagList.some((item) => item.id === obj?.payload?.id)
      if (checked && !targetInList) return setViewTagList((oldArr) => [...oldArr, obj?.payload])
      if (viewTagList?.length === 1) return // if last tag not allow to remove
      if (!checked && targetInList) return setViewTagList(viewTagList.filter((value) => value.id !== obj?.payload?.id))
    }
    // will not exit 2 garmin in once, so can compare by 'name'
    if (obj.type === 'garmin') {
      const targetInList = viewTagList.some((item) => item.name === obj?.payload?.name)
      if (checked && !targetInList) return setViewTagList((oldArr) => [...oldArr, obj?.payload])
      if (viewTagList?.length === 1) return // if last tag not allow to remove
      if (!checked && targetInList)
        return setViewTagList(viewTagList.filter((value) => value.name !== obj?.payload?.name))
    }
  }

  const handleDisableCheck = (obj: HandleToggleTaskPayload) => {
    if (viewTagList?.length !== 1) return false
    if (obj.type === 'task' && viewTagList?.length === 1) return viewTagList?.some((item) => item.id === obj.payload.id)
    if (obj.type === 'garmin' && viewTagList?.length === 1) {
      return viewTagList?.some((item) => item.name === obj.payload.name)
    }
  }

  return (
    <div
      id='viewMenu'
      css={{
        width: '315px',
        border: `1px solid ${color.border.disabled}`,
        boxShadow: '0px 4px 10px 1px rgba(104, 104, 104, 0.25)',
        borderRadius: '5px',
        background: color.white,
        cursor: 'auto',
        padding: '20px',
        paddingBottom: '5px',
      }}>
      {/* switch */}
      <div css={{borderBottom: `1px solid ${color.grey_100}`, display: 'flex', marginBottom: '20px'}}>
        <div
          onClick={() => setAdherenceViewedByType(AdherenceViewedByType.Tasks)}
          style={
            {
              color: adherenceViewedByType === AdherenceViewedByType.Tasks && color.primary,
              borderBottom: adherenceViewedByType === AdherenceViewedByType.Tasks && `2px solid ${color.primary}`,
              paddingBottom: '15px',
              fontWeight: fontWeight.bold,
              marginRight: '30px',
              cursor: 'pointer',
            } as CSSProperties
          }>
          By Tasks
        </div>
        {/* 
        {RIF(
          garminDirectEnabled,
          <div
            onClick={() => setAdherenceViewedByType('DeviceDataType')}
            style={
              {
                color: adherenceViewedByType === 'DeviceDataType' && color.primary,
                borderBottom: adherenceViewedByType === 'DeviceDataType' && `2px solid ${color.primary}`,
                paddingBottom: '15px',
                fontWeight: fontWeight.bold,
                marginRight: '30px',
                cursor: 'pointer',
              } as CSSProperties
            }
          >
            By Device Data Type
          </div>,
        )} */}
      </div>

      {RIF(
        adherenceViewedByType === AdherenceViewedByType.Tasks,
        <div>
          {RIF(
            garminConnect,
            <label
              css={{
                display: 'flex',
                alignItems: 'start',
                width: 'fit-content',
                marginBottom: '15px',
                cursor: 'pointer',
              }}>
              <Checkbox
                value={viewTagList?.some((obj) => obj.name === 'Garmin Connect App')}
                onChange={(checked: boolean) =>
                  handleToggleTask(checked, {
                    type: 'garmin',
                    payload: {
                      name: 'Garmin Connect App',
                      color: color.black,
                    },
                  })
                }
                disableCheck={handleDisableCheck({
                  type: 'garmin',
                  payload: {
                    name: 'Garmin Connect App',
                    color: color.black,
                  },
                })}
              />
              <div css={{margin: 'auto 6px', marginTop: '-2px'}}>Garmin Connect App</div>
              <div
                css={{
                  borderRadius: '50%',
                  width: '13px',
                  height: '13px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <img src={GarminGIcon} width='13' />
              </div>
            </label>,
          )}

          {RIF(
            garminDirectEnabled,
            <label
              css={{
                display: 'flex',
                alignItems: 'start',
                width: 'fit-content',
                marginBottom: '15px',
                cursor: 'pointer',
              }}>
              <Checkbox
                value={viewTagList?.some((obj) => obj.name === 'Labfront Companion App')}
                onChange={(checked: boolean) =>
                  handleToggleTask(checked, {
                    type: 'garmin',
                    payload: {
                      name: 'Labfront Companion App',
                      id: garminDeviceTask?.id,
                      color: color.primary,
                    },
                  })
                }
                disableCheck={handleDisableCheck({
                  type: 'garmin',
                  payload: {
                    name: 'Labfront Companion App',
                    id: garminDeviceTask?.id,
                    color: color.primary,
                  },
                })}
              />
              <div css={{margin: 'auto 6px', marginTop: '-2px'}}>Labfront Companion App</div>
              <div
                css={{
                  background: color.primary,
                  color: color.white,
                  borderRadius: '50%',
                  fontSize: '7px',
                  width: '13px',
                  height: '13px',
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '2px',
                  paddingBottom: '1px',
                  justifyContent: 'center',
                }}>
                <img src={GarminLIcon} width='13' />
              </div>
            </label>,
          )}

          {RIF(
            selectTaskList,
            selectTaskList?.map((item) => (
              <label
                key={item.id}
                css={{
                  display: 'flex',
                  alignItems: 'start',
                  width: 'fit-content',
                  marginBottom: '15px',
                  cursor: 'pointer',
                }}>
                <Checkbox
                  value={viewTagList?.some((obj) => obj.id === item.id)}
                  onChange={(checked: boolean) => handleToggleTask(checked, {type: 'task', payload: item})}
                  disableCheck={handleDisableCheck({type: 'task', payload: item})}
                />
                <div css={{margin: 'auto 6px', maxWidth: '89%', marginTop: '-2px'}}>{item.name}</div>
              </label>
            )),
          )}
        </div>,
      )}

      {RIF(
        adherenceViewedByType === AdherenceViewedByType.DeviceDataType && garminDirectEnabled,
        <div>
          <div>Below are data type collected from Labfront Companion App:</div>
          <div css={{display: 'flex', flexDirection: 'column', marginTop: '15px'}}>
            {garminDirectList?.map((item, index) => (
              <label key={index} css={{marginBottom: '15px', cursor: 'pointer'}}>
                <input
                  type='radio'
                  name='dataType'
                  defaultChecked={item === viewDatatype}
                  onClick={(e: any) => setViewDatatype(e?.target?.labels[0]?.innerText)}
                />
                {item}
              </label>
            ))}
          </div>
        </div>,
      )}
    </div>
  )
}
